import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import Rotas from './rotas';
import { CidadeProvider } from 'services/cidade';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CidadeProvider>
    <Rotas />
  </CidadeProvider>
);
